import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { enroll } from '../lib/auth/passkey';
import { useAuth } from '../lib/auth/AuthProvider';
import './auth.css';

export default function EnrollPasskeyScreen() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const email = params.get('email') ?? '';
  // Handed off from VerifyOtpScreen via router state (S6c 1b CRITICAL fix) —
  // proves THIS browser is the one that just verified the email OTP.
  // Never in the URL/localStorage; lost on a hard reload by design, which
  // just means the user re-verifies the code.
  const enrollmentTicket = (location.state as { enrollmentTicket?: string } | null)?.enrollmentTicket;
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onEnroll() {
    setBusy(true); setError('');
    try {
      await enroll(email, navigatorLabel(), enrollmentTicket);
      await auth.signInWithPasskey(email);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Passkey setup was cancelled.');
    } finally { setBusy(false); }
  }

  return (
    <section className="auth">
      <div className="auth__card">
        <p className="auth__kicker">One last thing</p>
        <h1 className="auth__title">Seal your vault with a passkey.</h1>
        <p className="auth__sub">
          Your passkey is the only key to your vault — it lives on this device and unlocks with your face or fingerprint.
          It is required; nothing you record can be protected without it.
        </p>
        <p className="auth__alert" role="alert">{error}</p>
        <div className="la-cta-wrap">
          <button className="la-btn-primary" type="button" onClick={onEnroll} disabled={busy}>
            {busy ? 'Creating…' : 'Create your passkey'}
          </button>
        </div>
      </div>
    </section>
  );
}

function navigatorLabel(): string {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/iPhone|iPad/.test(ua)) return 'iOS device';
  if (/Android/.test(ua)) return 'Android device';
  if (/Mac/.test(ua)) return 'Mac';
  if (/Windows/.test(ua)) return 'Windows PC';
  return 'This device';
}
